import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=8baacc50&scoped=true&"
import script from "./LeadDetails.vue?vue&type=script&lang=js&"
export * from "./LeadDetails.vue?vue&type=script&lang=js&"
import style0 from "./LeadDetails.vue?vue&type=style&index=0&id=8baacc50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8baacc50",
  null
  
)

export default component.exports